import React from 'react'
import StateWrapper from './StateWrapper'

const ErrorState = props => <StateWrapper {...props} icon='LinkInterrupt' />

export default ErrorState
